import { useNavigate } from 'react-router-dom';
import CloseAppRoot from './_components/close-app';
import GiftCardTransaction from './_components/gift-card-transaction';
import ScanGiftCard from './_components/scan-gift-card';

export default function GiftCardPage() {
  const navigate = useNavigate();
  const onNavigate = (path: string) => {
    navigate(path);
  };
  return (
    <>
      <CloseAppRoot />
      <div className="fixed inset-0 flex size-full items-center justify-center gap-6 overflow-hidden px-24">
        <ScanGiftCard onNavigate={onNavigate} />
        <GiftCardTransaction onNavigate={onNavigate} />
      </div>
    </>
  );
}
